export default function CTASection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/7925ad02a2b2af3eb9a1737042ac27b5.jpg"
              alt="Relocate with Confidence"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70"></div>
          </div>

          <div className="relative px-12 py-20 text-center">
            <h2 className="text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              Relocate with Confidence
            </h2>
            
            <p className="text-xl text-gray-100 mb-4 max-w-3xl mx-auto leading-relaxed">
              Relocation is one of life's biggest decisions. Your travel planning should support it — not complicate it.
            </p>

            <p className="text-lg text-gray-200 mb-10 max-w-3xl mx-auto">
              <strong>Alwaz Travels offers trusted UK-based guidance for Saudi relocation and long-stay travel</strong>, helping you move with clarity and confidence.
            </p>

            <div className="flex flex-wrap justify-center gap-4 mb-12">
              <a
                href="/contact"
                className="inline-block px-10 py-5 bg-[#C9A961] text-white rounded-lg hover:bg-[#B89851] transition-colors whitespace-nowrap cursor-pointer font-semibold text-lg"
              >
                Book Your Consultation
              </a>
              <a
                href="tel:02034884455"
                className="inline-flex items-center gap-2 px-10 py-5 bg-white text-[#1A1F2E] rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer font-semibold text-lg"
              >
                <i className="ri-phone-line"></i>
                0203 4884455
              </a>
            </div>

            <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <i className="ri-phone-line text-3xl text-[#C9A961] mb-3"></i>
                <div className="text-white font-semibold mb-1">Call Us</div>
                <a href="tel:02034884455" className="text-gray-200 hover:text-[#C9A961] transition-colors cursor-pointer">
                  0203 4884455
                </a>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <i className="ri-whatsapp-line text-3xl text-[#C9A961] mb-3"></i>
                <div className="text-white font-semibold mb-1">WhatsApp</div>
                <a
                  href="https://wa.me/447362505895"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-200 hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  +44 7362 505895
                </a>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
                <i className="ri-mail-line text-3xl text-[#C9A961] mb-3"></i>
                <div className="text-white font-semibold mb-1">Email</div>
                <a
                  href="mailto:contact@alwaztravels.com"
                  className="text-gray-200 hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  contact@alwaztravels.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8 text-center">
          <div className="p-6">
            <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/10 rounded-2xl mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-[#C9A961]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1A1F2E] mb-2">ATOL Protected</h3>
            <p className="text-gray-600">Full financial protection for your peace of mind</p>
          </div>

          <div className="p-6">
            <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/10 rounded-2xl mx-auto mb-4">
              <i className="ri-customer-service-2-line text-3xl text-[#C9A961]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1A1F2E] mb-2">24/7 UK Support</h3>
            <p className="text-gray-600">Always here when you need us most</p>
          </div>

          <div className="p-6">
            <div className="w-16 h-16 flex items-center justify-center bg-[#C9A961]/10 rounded-2xl mx-auto mb-4">
              <i className="ri-award-line text-3xl text-[#C9A961]"></i>
            </div>
            <h3 className="text-xl font-bold text-[#1A1F2E] mb-2">15+ Years Experience</h3>
            <p className="text-gray-600">Trusted by over 1000 families</p>
          </div>
        </div>
      </div>
    </section>
  );
}
